module.exports = __webpack_public_path__ + "img/level_four_lock.e463e114.png";